import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { Fade, Menu, MenuItem, Skeleton } from '@mui/material';
import { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { navigateToBaseUrl } from '../../../utils/navigator';
import { SETTINGS } from '../../../constants/routes';
import Button from '../../atoms/button';
import Modal from '../../organisms/modal';
import UpgradeToProModal from '../../organisms/upgrade-to-pro-modal';
import useWorkspace from '../../../context/WorkspaceContext';

const WorkspaceOptions = () => {
  // init
  const { workspace, showUpgradePlan, setShowUpgradePlan, isFreeTrial } = useWorkspace();
  const navigate = useNavigate();

  // states
  const [isSignOutModalOpen, setIsSignOutModalOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [anchorElement, setAnchorElement] = useState(null);

  const workspaceOptions = useMemo(() => [
    {
      id: 1,
      isVisible: true,
      label: 'Edit Workspace',
      handleClick: () => navigate(`/${SETTINGS}`),
    },
    {
      id: 2,
      isVisible: isFreeTrial,
      label: 'Upgrade to Pro',
      handleClick: () => { setShowUpgradePlan(true); setIsDropdownOpen(false); },
    },
    {
      id: 3,
      isVisible: true,
      label: 'Sign Out',
      handleClick: () => { setIsSignOutModalOpen(true); setIsDropdownOpen(false); },
    },
  ], [workspace]);

  const handleClose = () => {
    setIsDropdownOpen(false);
  };

  const handleFreeTrialBadgeClick = () => {
    setShowUpgradePlan(true);
  };

  const handleWorkspaceNameClick = (event) => {
    setAnchorElement(event.currentTarget);
    setIsDropdownOpen(true);
  };

  return (
    <div className="workspace-options-container">
      <Button disableRipple className="workspace-options-dropdown" primary text onClick={handleWorkspaceNameClick}>
        {
          workspace?.name
            ? <span className="workspace-name">{workspace?.name}</span>
            : <Skeleton animation="wave" variant="text" width={120} height={24} />
        }
        {isDropdownOpen ? <ExpandLess /> : <ExpandMore />}
      </Button>
      <Menu
        className="dropdown-add-member"
        id="fade-menu"
        MenuListProps={{
          'aria-labelledby': 'fade-button',
        }}
        anchorEl={anchorElement}
        open={isDropdownOpen}
        onClose={handleClose}
        TransitionComponent={Fade}
      >
        {workspaceOptions.map((option) => (
          option.isVisible &&
          <MenuItem key={option.id} value={`${option.id}`} onClick={option.handleClick}>
            {option.label}
          </MenuItem>
        ))}
      </Menu>
      <Modal
        title={`Leave ${workspace?.name} workspace`}
        body={`Are you sure you want to leave from ${workspace?.name} workspace?`}
        secondaryButton={(<Button onClick={() => navigateToBaseUrl()} danger>Leave</Button>)}
        primaryButton={(<Button primary outlined onClick={() => setIsSignOutModalOpen(false)}>Stay in Workspace</Button>)}
        isOpen={isSignOutModalOpen}
        actionAlignment="right"
        setIsOpen={() => setIsSignOutModalOpen((prev) => !prev)}
      />
      <UpgradeToProModal setIsDialogOpen={setShowUpgradePlan} isDialogOpen={showUpgradePlan} />
      {workspace && (!isFreeTrial && <span className="pro-subscription-badge">Pro</span>)}
      {workspace && (isFreeTrial && <button type="button" onClick={handleFreeTrialBadgeClick} className="free-subscription-badge">Free Trial</button>)}
    </div>
  );
};

export default WorkspaceOptions;
